import React from "react";
import { Eye } from "lucide-react";

export const VIEW_BADGE_MIN = 10;

// Social-proof badge for paid listings: "Viewed by 40+ buyers this month" (rounded down to the nearest 10).
export default function ViewBadge({ views, listingId, size = "sm" }) {
  if (!views || views < VIEW_BADGE_MIN) return null;
  const rounded = Math.floor(views / 10) * 10;
  return (
    <div
      className={`inline-flex items-center gap-1 font-medium uppercase tracking-[0.15em] text-[#B8860B] bg-[#FFFBEB] border border-[#B8860B]/40 ${size === "md" ? "text-[11px] px-2.5 py-1" : "text-[10px] px-1.5 py-0.5"}`}
      data-testid={`view-badge-${listingId}`}
      title={`${views} buyer profile views so far this month`}
    >
      <Eye className={size === "md" ? "w-3.5 h-3.5" : "w-3 h-3"} /> Viewed by {rounded}+ buyers this month
    </div>
  );
}
